import React, { useState } from "react";
import MultiLanguages from "@admin/components/MultiLanguage";
import type { Language } from "@admin/domain/languages/helpers";
import Input from "@admin/components/Input";
import VideoInput from "../../../components/VideoInput";
import { ProductVideoModel } from "@admin/domain/products/models/edit/ProductVideoModel";

type Props = {
    initVideo: ProductVideoModel | null;
};

export default function ExpertOpinionVideo({ initVideo }: Props) {
    const [video, setVideo] = useState<ProductVideoModel | null>(initVideo);

    const add = () => {
        setVideo({
            id: 0,
            file: null,
            url: null,
            texts: [],
        });
    };

    return (
        <div className="rounded border p-10 mb-5">
            <h4 className="mb-5">Видео</h4>

            {video && (
                <div className="mb-5">
                    <div className="card border mb-4">
                        <div className="card-body">
                            {video.id !== 0 && <input type="hidden" name="expert[video][id]" defaultValue={video.id} />}

                            <VideoInput
                                name="expert[video]"
                                defaultValue={{
                                    file: video.file,
                                    url: video.url,
                                }}
                            />

                            <MultiLanguages
                                languageElement={(language: Language): React.JSX.Element => (
                                    <>
                                        <input
                                            type="hidden"
                                            name={`expert[video][texts][${language}][language]`}
                                            defaultValue={language}
                                        />

                                        <Input
                                            label="Название"
                                            name={`expert[video][texts][${language}][title]`}
                                            defaultValue={
                                                video.texts.find((item) => item.language === language)?.title || ``
                                            }
                                        />
                                    </>
                                )}
                            />

                            <button
                                type="button"
                                className="btn btn-sm btn-link text-danger"
                                onClick={() => setVideo(null)}
                            >
                                Удалить
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {!video && (
                <div className="mt-5">
                    <button type="button" className="btn btn-primary" onClick={add}>
                        Добавить видео
                    </button>
                    <input type="hidden" name="expert[video]" value="" />
                </div>
            )}
        </div>
    );
}
